import { LotteryTags } from "../../../../models/modules/lotteryplatform-client.models";
import * as Enumerable from "linq";
var LotteryHelper = /** @class */ (function () {
    function LotteryHelper() {
    }
    LotteryHelper.getLotteryKey = function (name) {
        if (name)
            return name.toLowerCase().replace(/ /g, '-');
        return name;
    };
    LotteryHelper.getLotteryByKey = function (lotteries, key) {
        var _this = this;
        var lotteriesEnumerable = Enumerable.from(lotteries);
        if (key == LotteryTags.HighestJackpot) {
            var topLottery = lotteriesEnumerable.orderByDescending(function (lottery) { return lottery.totalJackpot; }).firstOrDefault();
            return topLottery;
        }
        else if (key == LotteryTags.SecondHighestJackpot) {
            var topLottery = lotteriesEnumerable.orderByDescending(function (lottery) { return lottery.totalJackpot; }).skip(1).firstOrDefault();
            return topLottery;
        }
        else if (key == LotteryTags.ThirdHighestJackpot) {
            var topLottery = lotteriesEnumerable.orderByDescending(function (lottery) { return lottery.totalJackpot; }).skip(2).firstOrDefault();
            return topLottery;
        }
        else if (key == LotteryTags.NextClosingLottery) {
            var topLottery = lotteriesEnumerable
                .where(function (x) { return x.closingDateTime != null && x.closingDateTime != undefined; })
                .where(function (x) { return new Date(x.closingDateTime) >= new Date(); })
                .orderBy(function (lottery) {
                return new Date(lottery.closingDateTime);
            }).firstOrDefault();
            return topLottery;
        }
        else {
            var lotteryByName = lotteriesEnumerable.firstOrDefault(function (x) { return _this.getLotteryKey(x.lotteryName) == key; });
            return lotteryByName;
        }
    };
    return LotteryHelper;
}());
export { LotteryHelper };
